import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { UserNotesComponent } from './user-notes.component';
import { SharedModule } from '@shared/shared.module';
// Note: UserService is provided in root, so we don't need to import UserModule

/**
 * Standalone UserNotesModule
 * Can be imported into any module without routing conflicts
 */
@NgModule({
    declarations: [UserNotesComponent],
    imports: [
        CommonModule,
        FormsModule,
        SharedModule
    ],
    exports: [UserNotesComponent]
})

export class UserNotesModule { }
